import { Page, PageHeader } from "@dash/page";

import { useClientManager } from "@megaron/react-clients";

import { SyncBar } from "./SyncBar";
import { SyncResultView } from "./SyncResultsView";

export const ExportShopifyProductsPage = () => {
  const query = useClientManager("catalog").exportShopifyProducts().useQuery({
    dryRun: true,
  });

  const commitMutation = useClientManager("catalog").exportShopifyProducts().useMutation();

  const commit = async () => {
    await commitMutation.mutateAsync({
      dryRun: false,
    });
  };

  return (
    <Page css={{ maxWidth: "100%", gap: "1rem", display: "flex", flexDirection: "column" }}>
      <PageHeader>Eksportuj produkty Shopify</PageHeader>
      <SyncBar
        onCommit={commit}
        isLoading={query.isLoading || commitMutation.isLoading}
        isDisabled={!query.data?.operations.length}
      />

      <SyncResultView
        isLoading={query.isLoading}
        result={query.data}
        labels={{
          description: "Opis",
          handle: "Handle",
          id: "ID",
          tags: "Tagi",
          title: "Tytuł",
          vendor: "Marka",
        }}
      />
    </Page>
  );
};
